import { Typography } from "@mui/material";

export function EmptyMessage({ children }: { children: string }) {
  return (
    <Typography sx={{ color: "#A0A0A0", fontStyle: "italic" }}>
      {children}
    </Typography>
  );
}
